var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import IconPlayButtonBlackOutline from '@backrs_ui/common-ui/src/assets/images/play_button_black_outline.svg';
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { RADIUS } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';
import { Box } from '@mui/material';
export var VideoUpload = function (_a) {
    var mode = _a.mode, videoUrl = _a.videoUrl, onVideoChange = _a.onVideoChange, _b = _a.roundedCorners, roundedCorners = _b === void 0 ? true : _b;
    var _c = useState(false), isPlaying = _c[0], setIsPlaying = _c[1];
    var fileInputRef = useRef(null);
    var handlePlayClick = useCallback(function () {
        var _a;
        if (mode === 'edit') {
            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
        else {
            setIsPlaying(function (prev) { return !prev; });
        }
    }, [mode]);
    var handleFileChange = useCallback(function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file && onVideoChange) {
            onVideoChange(file);
        }
    }, [onVideoChange]);
    var handleVideoEnd = useCallback(function () {
        setIsPlaying(false);
    }, []);
    var showOverlay = mode === 'edit' || (mode === 'view' && !isPlaying);
    return (_jsxs(Box, { className: "profile-video", position: "relative", onClick: mode === 'edit' ? handlePlayClick : undefined, children: [showOverlay && (_jsx(Box, { component: "img", sx: playButtonContainerStyle, onClick: handlePlayClick, src: IconPlayButtonBlackOutline, width: 56, height: 56 })), _jsx(Box, { sx: __assign({ borderRadius: roundedCorners ? RADIUS['radius-2xl'] : '0' }, videoPlayerStyle), children: _jsx("video", { width: "100%", height: "100%", src: videoUrl, style: htmlVideoStyle, controls: isPlaying, onEnded: handleVideoEnd }) }), mode === 'edit' && (_jsx("input", { type: "file", ref: fileInputRef, onChange: handleFileChange, accept: "video/*", style: { display: 'none' } }))] }));
};
var videoPlayerStyle = {
    overflow: 'hidden',
    width: '100%',
    aspectRatio: '16 / 9',
};
var playButtonContainerStyle = {
    position: 'absolute',
    bottom: '12%',
    left: '5%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 1,
};
var htmlVideoStyle = {
    objectFit: 'contain',
    backgroundColor: COLOR_TOKENS['Colors/Base/Black'],
};
